// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vant from 'vant'
import router from './router'
import http from '../src/lib/http';
import store from './store/index'
import install from './lib/install'
import {getBrower, getENV, getParamsFromUrl, makeUrl, setTitle} from './lib/utils'
import VueClipboard from 'vue-clipboard2'
import VConsole from 'vconsole'
import urlHistory from './lib/urlHistory'
import {openidCache,OnlineHosCache,SelectedHosCache} from "./lib/cache";

Vue.use(install)
Vue.use(Vant);
Vue.use(VueClipboard)

/* if (process.env.NODE_ENV === 'production') {
  new VConsole()
} */

// 使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  Log('to,from', to, from)
  urlHistory.set(to.fullPath)
  let {title} = to.meta
  if (title) {
    setTitle('三博云医')
  } else {
    setTitle('三博云医')
  }
  next()
})

Vue.config.productionTip = false
Log('url', location.href)
// let openId = openidCache.get();
let openId = sessionStorage.getItem('OPENID')
Log('openId', openId);
let urlParams = getParamsFromUrl(location.href);
let {query = {}} = urlParams;
Log('query', query);
const {NODE_ENV} = process.env;
Log('NODE_ENV', NODE_ENV);

if (query && query.debug) {
  new VConsole();
}


if (!query || !query.version) {//链接自动加版本号
  query = Object.assign({}, query, {version: VERSION})
  location.replace(makeUrl(Object.assign({}, urlParams, {query})))
} else if (NODE_ENV === 'development') {//开发环境
  doOauth()
} else if (NODE_ENV === 'production') {//非开发环境
  if (getBrower() === 'other') {//非微信支付宝打开
    run();
  } else {//微信支付宝打开
    doOauth()
  }
}

if (query && query.vdebug){
  new VConsole()
}

/*if (!openidCache.get() && !query.token) {
  goOauth()
} else if (!query || !query.version) {
  query = Object.assign({}, query, {version: VERSION})
  location.replace(makeUrl(Object.assign({}, urlParams, {query})))
} else {
  run()
}*/

async function doOauth() {
  if (!openId && !query.token) {
    goOauth();
  } else {
    run();
  }
}

function goOauth() {
  //哪个公众号跳转过来的走哪个appid授权
  let {appid} = getENV()
  let {query} = getParamsFromUrl(location.href)
  let Oauth_Appid = query.appId || appid ;
  location.replace('oauth2.html?appid='+Oauth_Appid+'&callback=' + encodeURIComponent(location.href))
}

async function run() {
  // 通过一个空的vue实例放出一个全局的方法
  window.bus = new Vue()
  const { code, list = [] } = await http('smarthos.system.hos.list', {});
  OnlineHosCache.set(list)
  new Vue({
    el: '#app',
    router,
    store,
    async created(){
      // let {appid} = getENV()
      // let {query} = getParamsFromUrl(location.href)
      // let Oauth_Appid = query.appId || appid ;
      // this.$cache.set('Oauth_Appid',Oauth_Appid)
      // //查询平台所有医院 放入缓存 必须在最前面执行防止后面出错
      //await this.getOnlineHosList();
    },
    methods:{
      /***
       *  获取平台多医院列表
       *
       */
      async getOnlineHosList() {
        const { code, list } = await this.$http('smarthos.system.hos.list', {});
        if (code === '0') {
          OnlineHosCache.set(list)
        }
      }
    },
    components: {App},
    template: '<App/>'
  })
}

/* eslint-disable no-new */



// WEBPACK FOOTER //
// ./src/main.js